import {Component, NgZone} from "@angular/core";
import {ModalConfig} from "../../services/notification/modal.config";
import {EventBus} from "../../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ActivityEventData} from "../../event/ActivityEvent";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {RuntimeTestEvent} from "../../event/RuntimeTestEvent";
import {RuntimeTestService, RuntimeCheck} from "./runtimetest.service";
import {ComponentBase} from "../../base/ComponentBase";
import {RaVersion} from "../../services/configuration/ra.version";
import {filter} from "rxjs/operators";

@Component({
    selector: "runtimetest-modal",
    templateUrl: "./runtimetest.modal.component.html",
    styleUrls: ["./runtimetest.modal.component.scss"]
})
export class RuntimeTestModalComponent extends ComponentBase {

    private modalType: string = "runtimetest";
    public activateModal: boolean = false;
    public status:string = "";
    public volumeProgress:number = 0;

    constructor(
        private runtimeTestService:RuntimeTestService,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone) {
        super("RuntimeTestModalComponent");
        this.subscribeObserve();
    }

    private subscribeObserve():void {
        let sub = this.eventBus.pipe(filter((e:RuntimeTestEvent) => e.type === RuntimeTestEvent.TYPE))
            .subscribe((e:RuntimeTestEvent) => {
               this.activateModal = true;
            });
        this.subscriptions.push(sub);

        sub = this.runtimeTestService.runtimeTestServiceStatus.subscribe((event) => {
            // during setup we accumulate status to TEST_READY
            if (event === RuntimeCheck.TEST_FINISHED_ALL) {
                this.updateStatus();
            }
        });
        this.subscriptions.push(sub);
    }

    public stopTest():void {
        this.runtimeTestService.stopTest();
    }

    public close():void {
        this._ngZone.run(() => {
            this.activateModal = false;
            this.modalConfig.removeModal(new ActivityEventData({type: this.modalType}));
        });
    }

    public startTest():void {
        this.runtimeTestService.runTest();
    }

    public updateStatus():void {
        this.status = this.runtimeTestService.status;
    }
}
